// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"f5f7d95063f74a0bb77c","678":"4f6452f5a26ff89e904e","883":"733681050d22298386ed"}[chunkId] + ".js";
};